import styled from "@emotion/styled";

import { Header } from "../../../common/components/table/Header";

export const HeaderWrapper = styled(Header)`
    display: flex;
`;
